import { observer } from 'mobx-react-lite';

import Stack from "@mui/joy/Stack";
import Divider from "@mui/joy/Divider";
import Typography from "@mui/joy/Typography";

import usePhone from '../hooks/usePhone';

import CollabCallItem from './CollabCallItem';

const PhoneTopperCallStatus = observer(() => {
    const { activeCallKey, getCall } = usePhone();
    const call = getCall(activeCallKey || '');

    if(!activeCallKey || !call) {
        return (
            <Stack>
                <Divider>Call Status</Divider>
                <Typography level="body-sm">Not on a call</Typography>
            </Stack>
        );
    }

    return (
        <Stack>
            <Divider>Call Status</Divider>
            <CollabCallItem call={call} expanded={true} showControls={true}/>
        </Stack>
    );
});

export default PhoneTopperCallStatus;
